import React from 'react';
import "../template-file-css/document-file-template.css";


export const GHP_IndividualStatusReport = ({ itemsRef, showErrorFor }) => {

    return (
        <form id='GHP_IndividualStatusReport' className='file-pdf-document'>
            <div className='file-template'>


                <h3>INDIVIDUAL STATUS REPORT</h3>

                <table>
                    <tr>
                        <td className="w-375"><span className="eleHeader w-375;">I.  Individual Name:</span></td>
                        <td className="w-375"><span className="eleHeader w-375;">Month/Year</span></td>
                    </tr>
                    <tr>
                        <td className="w-375">
                            <input type="text" id="txtIndividualName" name="txtIndividualName" className="add-only" />
                        </td>
                        <td className="w-375">
                            <input type="text" id="txtMonth" name="txtMonth" className="add-only" />
                        </td>
                    </tr>
                </table>
                <h2>II. Treatment Team:</h2>
                <h3>Printed Name/Position</h3>
                <table>
                    <tr>
                        <td className="w-375">
                            <span className="eleHeader w-375;">Therapist (if Applicable)</span>
                            <input type='text' id="txt_2" name="txt_2" className="add-only" />
                        </td>
                        <td className="w-375">
                            <span className="eleHeader w-375;">Paraprofessional (if applicable)</span>
                            <input type='text' id="txt_3" name="txt_3" className="add-only" />
                        </td>
                    </tr>
                    <tr>
                        <td className="w-375">
                            <span className="eleHeader w-375;">CAC (if applicable)</span>
                            <input type='text' id="txt_4" name="txt_4" className="add-only" />
                        </td>
                        <td className="w-375">
                            <span className="eleHeader w-375;">CPS (if applicable)</span>
                            <input type='text' id="txt_5" name="txt_5" className="add-only " />
                        </td>
                    </tr>
                </table>
                <h4>III. Discussion Notes/Significant Events since Last Team Meeting (Highlight achievements or lack thereof for CM, PSR, FT, ADSS or IN etc):</h4>
                <h6>Identify updates in any of the areas below that apply for the past 30 days:</h6>
                <p>
                    <span className="eleHeader">1.	Safety Concerns (SI/HI):</span>
                    <textarea id="txtSafety" name="txtSafety" className="add-only "></textarea>
                </p>
                <p>
                    <span className="eleHeader">2.	Crisis:</span>
                    <textarea id="txtCrisis" name="txtCrisis" className="add-only "></textarea>
                </p>
                <p>
                    <span className="eleHeader">3.	Active Psychosis (AVH/Delusions):</span>
                    <textarea id="txtActivePsychosis" name="txtActivePsychosis" className="add-only "></textarea>
                </p>
                <p>
                    <span className="eleHeader">4.	Medication Changes:</span>
                    <textarea id="txtMedication" name="txtMedication" className="add-only "></textarea>
                </p>
                <p>
                    <span className="eleHeader">5.	Progress Statement :</span>
                    <textarea id="txtProgress" name="txtProgress" className="add-only "></textarea>
                </p>
                <h3>IV. Revisions </h3>
                <p>
                    <span className="eleHeader">TREATMENT PLAN UPDATE NEEDED </span>
                    <tr>
                        <td className='w-187'>
                            <input type="radio" id="rbDischarge_Yes" name="rbDischarge" className="add-only" value="1" /> Yes
                        </td>
                        <td className='w-187'>
                            <input type="radio" id="rbDischarge_No" name="rbDischarge" className="add-only" value="0" /> No
                        </td>
                    </tr>
                </p>
                <p>
                    Comments/Recommendations
                </p>
                <textarea id="txtProgress11" name="txtProgress11" className="add-only "></textarea>


                <p>
                    <span className="eleHeader">REAUTHORIZATION NEEDED</span>
                    <tr>
                        <td className='w-187'>
                            <input type="radio" id="rbDischarge1_Yes" name="rbDischarge1" className="add-only" value="1" /> Yes
                        </td>
                        <td className='w-187'>
                            <input type="radio" id="rbDischarge1_No" name="rbDischarge1" className="add-only" value="0" /> No
                        </td>
                    </tr>
                </p>
                <p>
                    Comments/Recommendations
                </p>
                <textarea id="txtProgress1" name="txtProgress1" className="add-only "></textarea>

                <p>
                    <span className="eleHeader">REQUEST FOR DISCHARGE </span>
                    <tr>
                        <td className='w-187'>
                            <input type="radio" id="rbDischarge2_Yes" name="rbDischarge2" className="add-only" value="1" /> Yes
                        </td>
                        <td className='w-187'>
                            <input type="radio" id="rbDischarge2_No" name="rbDischarge2" className="add-only" value="0" /> No
                        </td>
                    </tr>
                </p>
                <p>
                    Comments/Recommendations
                </p>
                <textarea id="txtProgress2" name="txtProgress2" className="add-only "></textarea>

                <p>
                    <span className="eleHeader">REQUEST FOR HIGHER LEVEL OF CARE </span>
                    <tr>
                        <td className='w-187'>
                            <input type="radio" id="rbDischarge3_Yes" name="rbDischarge3" className="add-only" value="1" /> Yes
                        </td>
                        <td className='w-187'>
                            <input type="radio" id="rbDischarge3_No" name="rbDischarge3" className="add-only" value="0" /> No
                        </td>
                    </tr>
                </p>
                <p>
                    Comments/Recommendations
                </p>
                <textarea id="txtProgress3" name="txtProgress3" className="add-only "></textarea>

                <p>
                    <span className="eleHeader">REQUEST FOR LOWER LEVEL OF CARE</span>
                    <tr>
                        <td className='w-187'>
                            <input type="radio" id="rbDischarge4_Yes" name="rbDischarge4" className="add-only" value="1" /> Yes
                        </td>
                        <td className='w-187'>
                            <input type="radio" id="rbDischarge4_No" name="rbDischarge4" className="add-only" value="0" /> No
                        </td>
                    </tr>
                </p>
                <p>
                    Comments/Recommendations
                </p>
                <textarea id="txtProgress4" name="txtProgress4" className="add-only "></textarea>

                <h3>V. PLEASE CHECK THE FOLLOWING FOR LINKAGES COMPLETED AND DOCUMENTED IN THE LAST 30 DAYS:</h3>
                <table>
                    <tr>
                        <td className="w-250">
                            <input type="checkbox" name="chkBirthC" id="chkBirthC1" className="add-only" value="BIRTH CERTIFICATE" />BIRTH CERTIFICATE</td>
                        <td className="w-250">
                            <input type="checkbox" name="chkUtilityR" id="chkUtilityR1" className="add-only" value="UTILITY RESOURCES" />UTILITY RESOURCES</td>
                        <td className="w-250">
                            <input type="checkbox" name="chkMedical" id="chkMedical1" className="add-only" value="MEDICAL ATTENTION (IE. PCP)" />MEDICAL ATTENTION (IE. PCP)</td>
                    </tr>
                    <tr>
                        <td className="w-250">
                            <input type="checkbox" name="chkBirthC1" id="chkBirthC_1" className="add-only" value="IDENTIFICATION" />IDENTIFICATION</td>
                        <td className="w-250">
                            <input type="checkbox" name="chkUtilityR1" id="chkUtilityR_1" className="add-only" value="CHURCH" />CHURCH</td>
                        <td className="w-250">
                            <input type="checkbox" name="chkMedical1" id="chkMedical_1" className="add-only" value="PROBATION" />PROBATION</td>
                    </tr>
                    <tr>
                        <td className="w-250">
                            <input type="checkbox" name="chkBirthC2" id="chkBirthC_2" className="add-only" value="FOOD RESOURCES" />FOOD RESOURCES</td>
                        <td className="w-250">
                            <input type="checkbox" name="chkUtilityR2" id="chkUtilityR_2" className="add-only" value="COMMUNITY PROGRAMS" />COMMUNITY PROGRAMS</td>
                        <td className="w-250">
                            <input type="checkbox" name="chkMedical2" id="chkMedical_2" className="add-only" value="APS REPORT COMPLETED" />APS REPORT COMPLETED</td>
                    </tr>
                    <tr>
                        <td className="w-250">
                            <input type="checkbox" name="chkBirthC3" id="chkBirthC_3" className="add-only" value="FOOD RESOURCES" />CLOTHING RESOURCES</td>
                        <td className="w-250">
                            <input type="checkbox" name="chkUtilityR3" id="chkUtilityR_3" className="add-only" value="INDIVIDUALS RIGHTS GROUPS" />INDIVIDUALS RIGHTS GROUPS</td>
                        <td className="w-250">
                            <input type="checkbox" name="chkMedical3" id="chkMedical_3" className="add-only" value="DFCS REPORT COMPLETED" />DFCS REPORT COMPLETED</td>
                    </tr>
                    <tr>
                        <td className="w-250">
                            <input type="checkbox" name="chkBirthC4" id="chkBirthC_4" className="add-only" value="HOUSING RESOURCES" />HOUSING RESOURCES</td>
                        <td className="w-250">
                            <input type="checkbox" name="chkUtilityR4" id="chkUtilityR_4" className="add-only" value="AA/NA GROUPS" />AA/NA GROUPS</td>
                        <td className="w-250">&nbsp;</td>
                    </tr>
                </table>
                <p>
                    <input type="checkbox" name="chkMedical4" id="chkMedical_4" className="add-only" value="OTHER" />OTHER:&nbsp;
                    <textarea id="txtOther" name="txtOther" className="add-only "></textarea>
                </p>
                <p>
                    <span className="eleHeader">Please provide details of any items checked above:</span>
                    <textarea id="txtOther1" name="txtOther1" className="add-only "></textarea>
                </p>
                <p>
                    <span className="eleHeader">VI. Team Recommendations: </span>
                    <textarea id="txtOther2" name="txtOther2" className="add-only "></textarea>
                </p>
                <h3>VII. Update Individual information: </h3>
                <p>
                    <span className="eleHeader">Change of address/phone number:</span>
                    <textarea id="txtOther3" name="txtOther3" className="add-only "></textarea>
                </p>
                <p>
                    <span className="eleHeader">Updated PCP/Dentist or Psychiatric Information (name, address, phone and fax):</span>
                    <textarea id="txtOther4" name="txtOther4" className="add-only "></textarea>
                </p>

            </div>
        </form>
    )
}